<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       aria-label="Vimeo" role="img"
       viewBox="0 0 512 512"><rect
    width="512" height="512"
    rx="15%"
    fill="#1eb8eb"/><path d="m418 185c-19 109-128 202-161 223-32 21-62-9-73-30-12-26-49-164-59-176-9-12-39 12-39 12l-13-19s59-71 104-79c47-10 47 73 59 118 11 45 18 70 27 70 10 0 29-24 49-63 21-37-1-71-41-47 17-95 166-118 147-9z" fill="#ffffff"/></svg>
</template>